/* QRISTALINO v2 — popup de bienvenida con criterio (no interrumpe la compra ni la consulta por WhatsApp)
   Reglas: solo en inicio y colecciones · aparece a los 25 s o al intentar salir (escritorio) · máx. 1 vez cada 7 días
   · nunca si ya escribió por WhatsApp (qz_wa_sent) o llegó desde un anuncio a una ficha de producto */
document.addEventListener("DOMContentLoaded", function () {
  var popup = document.getElementById("qris-popup-overlay"), closeBtn = document.querySelector(".qris-popup-close");
  if (!popup || !closeBtn) return;
  var KEY = "qris_popup_closed_at", DAYS7 = 7 * 24 * 60 * 60 * 1000, DELAY = 25000;
  function ls(k, v) { try { return v === undefined ? localStorage.getItem(k) : localStorage.setItem(k, v); } catch (e) { return null; } }
  var page = document.body.getAttribute("data-qz-page") || "";
  var allowed = page === "index" || page === "collection" || page === "list-collections";
  var last = ls(KEY), recently = last && Date.now() - Number(last) < DAYS7;
  var shown = false;
  function show() { if (shown || ls("qz_wa_sent")) return; shown = true; popup.classList.add("active"); }
  function close() { popup.classList.remove("active"); ls(KEY, String(Date.now())); }
  closeBtn.addEventListener("click", close);
  popup.addEventListener("click", function (e) { if (e.target === popup) close(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  popup.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", function () { ls(KEY, String(Date.now())); }); });
  if (!allowed || recently) return;
  var t = setTimeout(show, DELAY);
  /* Intención de salida (solo con ratón): el cursor abandona la ventana por arriba */
  document.addEventListener("mouseout", function (e) {
    if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia("(hover:hover)").matches) { clearTimeout(t); show(); }
  });
});
